module.exports = __webpack_public_path__ + "img/resource-bg-green.80228172.png";